module.exports = __webpack_public_path__ + "img/矩形 2631.b511752b.png";